export default {
  maps: {
    map1: [
      [0,3,2,2,2,3,0],
      [0,3,2,2,2,3,0],
      [0,3,2,2,2,3,0],
      [0,3,0,'e',0,3,0],
      [0,4,0,0,0,4,0],
      [0,4,0,0,0,4,0],
      [0,3,0,0,0,3,0],
      [0,3,0,0,0,3,0],
      [0,3,0,0,0,3,0],
      [0,3,0,'s',0,3,0]
    ],
    map2: [
      [0,0,0,2,2,2,0],
      [0,0,3,2,2,2,0],
      [0,0,3,2,2,2,0],
      [0,0,3,0,'e',0,0],
      [0,0,3,0,0,3,0],
      [4,4,0,0,0,3,0],
      [0,0,0,0,0,3,0],
      [0,3,0,0,4,4,4],
      [0,3,0,0,0,0,0],
      [0,3,0,0,'s',0,0]
    ],

    map3: [
      [0,0,2,2,2,0,0],
      [0,0,2,2,2,0,0],
      [0,0,2,2,2,0,0],
      [4,4,4,'e',0,0,0],
      [3,0,0,0,0,0,0],
      [3,0,0,4,4,4,4],
      [0,0,0,0,0,3,0],
      [4,4,4,0,0,3,0],
      [0,0,0,0,0,3,0],
      [0,0,0,'s',0,3,0]
    ],

    map4: [
      [0,2,2,2,0,3,0],
      [0,2,2,2,0,3,0],
      [0,2,2,2,4,3,0],
      [0,0,'e',0,0,0,0],
      [0,4,4,4,4,0,0],
      [0,0,0,0,0,0,3],
      [0,0,0,0,0,3,3],
      [0,0,4,4,4,3,0],
      [0,0,0,0,0,3,0],
      [0,0,'s',0,3,0,0]
    ],

    map5: [
      [0,3,2,2,2,3,0],
      [0,3,2,2,2,3,0],
      [0,3,2,2,2,3,0],
      [0,3,0,'e',3,0,0],
      [0,0,0,4,4,4,4],
      [0,3,0,0,0,0,0],
      [0,4,4,4,0,0,0],
      [3,0,0,0,0,3,3],
      [3,0,3,4,4,4,0],
      [3,'s',3,0,0,0,0]
    ],

    map6: [
      [0,3,0,0,0,2,3],
      [0,3,0,0,0,2,3],
      [0,3,0,0,0,2,3],
      [4,4,4,4,'e',0,3],
      [0,3,0,0,0,3,4],
      [4,0,0,4,4,4,0],
      [0,3,0,0,0,0,0],
      [4,4,4,0,3,0,0],
      [0,3,0,0,4,4,4],
      [0,3,'s',0,0,0,0]
    ]
  },

  obstacles: [
    { obstacleId: 'rock-1',obstacleSize: 1,multidirectional: 1 },
    { obstacleId: 'rock-2',obstacleSize: 1,multidirectional: 1 },
    { obstacleId: 'rock-3',obstacleSize: 1,multidirectional: 1 },
    { obstacleId: 'rock-3',obstacleSize: 1,multidirectional: 1 },
    { obstacleId: 'spoon',obstacleSize: 3 },
    { obstacleId: 'fork',obstacleSize: 3 },
    { obstacleId: 'straw',obstacleSize: 3 }
  ]
};